var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { class: { pageSm: !_vm.isBigPage } },
    [
      !_vm.isBigPage
        ? _c("i", {
            staticClass: "ar_img el-icon-s-unfold zhankaiIcon",
            on: { click: _vm.changeMunuBig }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isBigPage
        ? _c(
            "el-aside",
            {
              staticClass: "animate",
              staticStyle: { "max-width": "200px" },
              attrs: { width: _vm.asideMaxWidth }
            },
            [
              _c("page-nav", {
                attrs: {
                  isBigPage: _vm.isBigPage,
                  collpanHeight: _vm.headerHeight,
                  isOpenMenu: _vm.isOpenMenu
                },
                on: { changeMunuBig: _vm.changeMunuBig }
              })
            ],
            1
          )
        : _c(
            "el-drawer",
            {
              attrs: {
                "custom-class": "nav_drawer",
                "with-header": false,
                visible: _vm.isOpenMenu,
                size: "40%",
                direction: _vm.direction
              },
              on: {
                "update:visible": function($event) {
                  _vm.isOpenMenu = $event
                }
              }
            },
            [
              _c("page-nav", {
                attrs: { collpanHeight: _vm.headerHeight },
                on: { changeMunuBig: _vm.changeMunuBig }
              })
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c(
            "el-header",
            { attrs: { height: _vm.headerHeight } },
            [_c("page-head")],
            1
          ),
          _vm._v(" "),
          _c("el-main", [_c("router-view")], 1)
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a82f956", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a82f956","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppIndex.vue
// module id = null
// module chunks = 